import { render, staticRenderFns } from "./SpcBrasil.vue?vue&type=template&id=1b0b25e0"
import script from "./SpcBrasil.vue?vue&type=script&lang=js"
export * from "./SpcBrasil.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports